import React, { FC, useCallback } from 'react'
import styles from 'styles/components/template.module.scss'
import { Spacer } from 'components/Utility'
import { useDispatch } from 'react-redux'
import { BlueButton, NavButton } from 'components/Button'
import { push } from 'connected-react-router'
import { Description, MainHeadline } from 'components/Typography'

const RevenueTemplate: FC = () => {
  const dispatch = useDispatch()
  const goToRealtimeRevenue = useCallback(() => dispatch(push('/account/revenue/realtime')), [])
  const goToMonthlyReport = useCallback(() => dispatch(push('/account/revenue/monthly_report')), [])
  const goToBalance = useCallback(() => dispatch(push('/account/revenue/balance')), [])
  const goToDepositHistory = useCallback(() => dispatch(push('/account/revenue/deposit_history')), [])

  return (
    <div className={styles.standard}>
      <Spacer size={28} />
      <MainHeadline headline={'売上確認'} />
      <Spacer size={28} />
      <Description description={'確認したいページをクリックしてください。'} />
      <Spacer size={20} />
      <Description
        fontWeight={'bold'}
        description={'注文日別やお客さまの受取日別など、リアルタイムの売上を確認できます'}
      />
      <Spacer size={20} />
      <BlueButton
        endIconPath={'/icon/white/arrow_next_small.svg'}
        label={'リアルタイム売上確認'}
        onClick={goToRealtimeRevenue}
        size={'medium'}
        type={'main'}
      />
      <Spacer size={20} />
      <Description fontWeight={'bold'} description={'毎月のsacriの手数料込みの売上レポートを確認できます。'} />
      <Spacer size={20} />
      <BlueButton
        endIconPath={'/icon/white/arrow_next_small.svg'}
        label={'月次レポート'}
        onClick={goToMonthlyReport}
        size={'medium'}
        type={'main'}
      />
      <Spacer size={20} />
      <Description
        fontWeight={'bold'}
        description={'現時点入金対象額を確認し、予めご設定頂いている銀行口座へ入金予約を行うことができます。'}
      />
      <Spacer size={20} />
      <BlueButton
        endIconPath={'/icon/white/arrow_next_small.svg'}
        label={'銀行振込'}
        onClick={goToBalance}
        size={'medium'}
        type={'main'}
      />
      <Spacer size={20} />
      <BlueButton
        endIconPath={'/icon/white/arrow_next_small.svg'}
        label={'入金履歴明細一覧'}
        onClick={goToDepositHistory}
        size={'medium'}
        type={'main'}
      />
      <Spacer size={48} />
      <NavButton label={'トップページに戻る'} iconPath={'/icon/grey/home.svg'} url={'/'} />
      <Spacer size={72} />
    </div>
  )
}

export default RevenueTemplate
